import { createContext } from "react";

const FactorContext = createContext();

export default FactorContext;
